import { Ref, nextTick } from 'vue';
import { useTimelineMapStore } from "@features/Pages/TimelineMapPage/_js/app/store/timelineMapStore";

export function useTimelineDom(timelineEl: Ref<HTMLElement | null>) {
    const store = useTimelineMapStore();

    function lockHeightOnce() {
        const el = timelineEl.value;
        if (!el) { return; }
        
        const h = el.getBoundingClientRect().height;
        el.style.minHeight = `${Math.ceil(h)}px`;
        requestAnimationFrame(() => { el.style.minHeight = ''; });
    }

    async function goToEpoch(newId: number) {
        lockHeightOnce();
        store.transitionToEpoch(newId);

        await nextTick();
        await new Promise(r => requestAnimationFrame(r));

        const titleEl = document.getElementById(`epoch-title-${newId}`);
        if (!titleEl) { return; }
    }

    return { goToEpoch };
}
